import { Document, Page, pdf, Text } from "@react-pdf/renderer"
import { styles, TableCell } from "components"
import { RowExportTypePdf } from "types"
import { useHandleAuth } from "utils"
import { PersonalList } from "../../types"

type UseExportPdf = {
  data: PersonalList[]
}

export const useExportPdf = ({ data }: UseExportPdf) => {
  const auth = useHandleAuth()
  const token = auth.userTokenData()

  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "ID VENDOR", key: "id", width: 12 },
    { header: "VENDOR", key: "name", width: 15 },
    { header: "HANDPHONE", key: "handphone", width: 15 },
    { header: "EMAIL", key: "email", width: 15 },
    { header: "CARD LABEL", key: "card", width: 10 },
    { header: "CATEGORY", key: "category", width: 15 },
    { header: "PRICE LEVEL", key: "price", width: 12 },
    { header: "BANK", key: "bank", width: 15 },
    { header: "BANK ACCOUNT", key: "account", width: 20 },
    { header: "COUNTRY", key: "country", width: 15 },
    { header: "PROVINCE", key: "province", width: 15 },
    { header: "REGENCY", key: "regency", width: 15 },
    { header: "SUBDISTRICT", key: "subdistrict", width: 15 },
    { header: "VILLAGE", key: "village", width: 12 },
    { header: "ADDRESS", key: "address", width: 15 },
  ]

  const dataMap: RowExportTypePdf[] = data.map((item, index) => {
    return {
      no: (index + 1).toString(),
      id: item.vendor_code ?? "-",
      name: item.vendor_name,
      handphone: item.handphone,
      email: item.email,
      card: item.card_label === 1 ? "Individu" : "Company",
      category: item.category_vendor_name,
      price: item.price_level_vendor_name,
      bank: item.bank_name,
      account: item.bank_account,
      country: item.country_name,
      province: item.province_name,
      regency: item.regency_name,
      subdistrict: item.subdistrict_name,
      village: item.village_name,
      address: item.address,
    }
  })

  return {
    handleExportPdf: () =>
      pdf(<PdfTemplate data={dataMap} column={columns} companyName={token?.company_name} />)
        .toBlob()
        .then((blob) => {
          const url = URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = url
          link.download = "register-vendor.pdf"
          link.click()
          URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error("Gagal membuat PDF:", error)
        }),
  }
}

function PdfTemplate({
  data,
  column,
  companyName
}: {
  data: RowExportTypePdf[]
  column: { header: string; key: string; width: number }[]
  companyName?: string
}) {
  return (
    <Document>
      <Page orientation="landscape" size="A4" style={{ ...styles.page }}>
        <Text
          style={{
            fontSize: 18,
            marginTop: 30,
            textAlign: "left",
            fontWeight: "heavy",
            textTransform: "uppercase"
          }}>
          CARDS
        </Text>
        <Text
          style={{
            fontSize: 18,
            marginBottom: 8,
            textAlign: "left",
            fontWeight: "heavy",
            textTransform: "uppercase"
          }}>
          REGISTER VENDOR
        </Text>

        <Text
          style={{
            fontSize: 12,
            marginBottom: 8,
            textAlign: "left",
            fontWeight: "medium"
          }}>
          {companyName?.toUpperCase() ?? ""}
        </Text>
        <TableCell data={data} column={column} />
      </Page>
    </Document>
  )
}
